import useInView from '../../hooks/useInView';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const WhatWeDo = () => {
  const [ref, inView] = useInView({ threshold: 0.15 });
  const { t } = useTranslation('common');
  return (
    <section ref={ref} className="bg-[#fff9ed] py-16 lg:py-24" id="about">
      <div className="container mx-auto px-8 lg:px-16">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Left Side - Images */}
          <div className="order-2 lg:order-1">
            <div className="relative max-w-lg mx-auto">
              <img 
                src="/assets/imgs/Home/About us/5.png" 
                alt="OASIS Image 1" 
                className={`w-[85%] rounded-lg shadow-2xl -rotate-3 transition-all duration-700 ease-out ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}
                style={{ transitionTimingFunction: 'cubic-bezier(0.22, 1, 0.36, 1)' }}
              />
            </div>
          </div>

          {/* Right Side - Content */}
          <div className="order-1 lg:order-2 relative">
            {/* Squirrel Right Decoration */}
            <img 
              src="/assets/imgs/Home/About us/4.png" 
              alt="Squirrel" 
              className={`absolute -top-4 right-0 w-28 lg:w-40 pointer-events-none hidden md:block transition-transform transition-opacity duration-700 ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}
              style={{ transitionTimingFunction: 'cubic-bezier(0.34, 1.56, 0.64, 1)' }}
            />
            
            <div className={`relative pr-28 lg:pr-48 transition-all duration-700 ease-out ${inView ? 'opacity-100 translate-x-0' : 'opacity-40 translate-x-6'}`}>
              {/* <p className="text-base font-semibold text-text-dark mb-2">Home</p> */}
              <h2 className="text-4xl lg:text-5xl font-bold text-text-dark mb-2">{t('home.whatWeDo.title')}</h2>

              <p className="text-base text-text-dark leading-normal mb-4">{t('home.whatWeDo.body')}</p>
              
              {/* Read More Button and Reviews */}
              <div className="flex flex-wrap items-center gap-6">
                <Link to="../about" className="bg-brown hover:bg-brown-dark text-cream px-8 py-3 rounded text-sm font-normal uppercase tracking-wide transition-all duration-300 hover:-translate-y-1 hover:shadow-lg">
                  {t('home.readMore')}
                </Link>
                
                {/* Reviews Section */}
                <div className="flex items-center gap-3">
                  {/* User Avatars */}
                  <div className="flex">
                    <img src="/assets/imgs/Home/About us/3.png" alt="User 1" className="w-10 h-10 rounded-full border-2 border-cream object-cover" />
                    <img src="/assets/imgs/Home/About us/3.png" alt="User 2" className="w-10 h-10 rounded-full border-2 border-cream object-cover -ml-3" />
                    <img src="/assets/imgs/Home/About us/3.png" alt="User 3" className="w-10 h-10 rounded-full border-2 border-cream object-cover -ml-3" />
                  </div>
                  
                  {/* Stars and Count */}
                  <div>
                    <div className="flex gap-0.5 mb-1">
                      {[...Array(5)].map((_, i) => (
                        <svg key={i} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="#fbaa33">
                          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                        </svg>
                      ))}
                    </div>
                    <p className="text-sm text-text-dark">(505.6K Reviews)</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhatWeDo;
